// Usage: Enables table sorter on the element this controller is attached to
// (usually a <table>).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).tablesorter({
      textExtraction: (node) => node.innerText.replace(/,/g, ""),
    });
  }
}
